import React, { createContext, useContext, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_FAV_SETTINGS_TAB } from './favoriteSettingsOptions';

const arraysAreEqual = (first, second) =>
    first.length === second.length && first.every((value, index) => value === second[index]);

export const FavoriteSettingsProvider = ({ children }) => {
    const [orderedFavoriteList, setOrderedFavoriteList] = useState([]);
    const [channelMap, setChannelMap] = useState({});
    const [activeDevice, setActiveDevice] = useState(null);
    const [activeTab, setActiveTab] = useState(DEFAULT_FAV_SETTINGS_TAB);
    const [dataChanged, setDataChanged] = useState(false);
    const [navigationPickerHeaderLayout, setNavigationPickerHeaderLayout] = useState(null);
    const [navigationPickerWidth, setNavigationPickerWidth] = useState(0);

    const previousOrderedFavoriteList = useRef([]);

    const filterFavoriteList = (channels, device) => {
        if (device && device.isDeviceIptv) {
            return [...new Set(channels)];
        }
        const filteredByMap =
            Object.keys(channelMap).length !== 0
                ? channels.filter((chId) => Boolean(channelMap[chId]))
                : channels;
        return [...new Set(filteredByMap)];
    };

    // Filter channel ids that are discarded in the channelMap and should not be available
    // and duplicit ids
    const setFilteredOrderedChannels = (channels, device) =>
        setOrderedFavoriteList(filterFavoriteList(channels, device));

    useEffect(() => {
        if (!arraysAreEqual(previousOrderedFavoriteList.current, orderedFavoriteList)) {
            setDataChanged(true);
            previousOrderedFavoriteList.current = orderedFavoriteList;
        }
    }, [orderedFavoriteList]);

    return (
        <FavoriteSettingsContext.Provider
            value={{
                orderedFavoriteList,
                setOrderedFavoriteList: setFilteredOrderedChannels,
                channelMap,
                setChannelMap,
                activeDevice,
                setActiveDevice,
                activeTab,
                setActiveTab,
                dataChanged,
                setDataChanged,
                navigationPickerHeaderLayout,
                setNavigationPickerHeaderLayout,
                navigationPickerWidth,
                setNavigationPickerWidth
            }}
        >
            {children}
        </FavoriteSettingsContext.Provider>
    );
};

FavoriteSettingsProvider.defaultProps = {
    children: []
};

FavoriteSettingsProvider.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

const FavoriteSettingsContext = createContext({});

export const useFavoriteSettingsContext = () => useContext(FavoriteSettingsContext);

export const withFavoriteSettingsContext = (Component) => (props) =>
    (
        <FavoriteSettingsContext.Consumer>
            {(context) => <Component {...props} {...context} />}
        </FavoriteSettingsContext.Consumer>
    );
